// extracted by mini-css-extract-plugin
export default {"container":"CurrencyInput_container__Ok5pB","input":"CurrencyInput_input__LeP+u","select":"CurrencyInput_select__03TuR"};